import React from 'react'
import MaterialSymbol from '../material-symbol'

const PushPin = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="push_pin" {...props} />
))

PushPin.displayName = 'PushPin'

export default PushPin
